import { render, staticRenderFns } from "./searchCollection.vue?vue&type=template&id=1997e444&scoped=true&"
import script from "./searchCollection.vue?vue&type=script&lang=js&"
export * from "./searchCollection.vue?vue&type=script&lang=js&"
import style0 from "./searchCollection.vue?vue&type=style&index=0&id=1997e444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1997e444",
  null
  
)

export default component.exports